import React from "react";

export const Preloader = () => {
  return <div id="preloader"></div>;
};
